import { NewRegistrationLanguage, NewRegistrationSkills  } from '../../new-registration.model';

export class CandidateLanguagesSkillsClass {
    languages?: NewRegistrationLanguage[];
    skills?: NewRegistrationSkills[];
    needAtLeastOne?: boolean;
}
